/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import VerticalSplit from "../../../Basis/Components/VerticalSplit";
import AppRouterDefinition from "./../../../AppRouterDefinition";

const SeminarEinstellungenZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarEinstellungenZusatzfelderBreadcrumb"));
const SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const SeminarZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarZusatzfeldDefinitionBreadcrumb"));
const SeminarZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarZusatzfeldDefinitionenBreadcrumb"));
const SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const SeminarZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarZusatzfeldDefinitionDetailsView"));
const SeminarZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarZusatzfeldDefinitionenNavigationView"));
const SeminarZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarZusatzfeldDefinitionenView"));
const SeminarZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarZusatzfeldDefinitionView"));
const SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const SeminarreiheZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarreiheZusatzfeldDefinitionBreadcrumb"));
const SeminarreiheZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarreiheZusatzfeldDefinitionenBreadcrumb"));
const SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const SeminarreiheZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheZusatzfeldDefinitionDetailsView"));
const SeminarreiheZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheZusatzfeldDefinitionenNavigationView"));
const SeminarreiheZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheZusatzfeldDefinitionenView"));
const SeminarreiheZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheZusatzfeldDefinitionView"));
const DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const DozierendZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/DozierendZusatzfeldDefinitionBreadcrumb"));
const DozierendZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/DozierendZusatzfeldDefinitionenBreadcrumb"));
const DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const DozierendZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendZusatzfeldDefinitionDetailsView"));
const DozierendZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendZusatzfeldDefinitionenNavigationView"));
const DozierendZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendZusatzfeldDefinitionenView"));
const DozierendZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendZusatzfeldDefinitionView"));
const ZahlungsdienstleisterView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/ZahlungsdienstleisterView"));
const ZahlungsmethodenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/ZahlungsmethodenView"));
const PayPalKontoView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../../../Management/Mandanten/Views/PayPalKontoView"));
const StripeKontoView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../../../Management/Mandanten/Views/StripeKontoView"));
const PayPalKontoBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../../../Management/Mandanten/Components/PayPalKontoBreadcrumb"));
const StripeKontoBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../../../Management/Mandanten/Components/StripeKontoBreadcrumb"));
const ZusatzfeldDefinitionenTabsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/ZusatzfeldDefinitionenTabsView"));
const AdresseZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../Views/AdresseZusatzfeldDefinitionView"));
const TeilnahmeZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "./../Views/TeilnahmeZusatzfeldDefinitionView"));
const TeilnahmeEinstellungenZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/TeilnahmeEinstellungenZusatzfelderBreadcrumb"));
const TeilnahmeZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/TeilnahmeZusatzfeldDefinitionenNavigationView"));
const TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const TeilnahmeZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/TeilnahmeZusatzfeldDefinitionBreadcrumb"));
const AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const AdresseZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName */ "../Views/AdresseZusatzfeldDefinitionDetailsView"));
const TeilnahmeZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName */ "../Views/TeilnahmeZusatzfeldDefinitionDetailsView"));
const AdresseZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/AdresseZusatzfeldDefinitionenNavigationView"));
const AdresseZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/AdresseeZusatzfeldDefinitionBreadcrumb"));
const AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const TeilnahmeZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/TeilnahmeZusatzfeldDefinitionenView"));
const AdresseZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/AdresseZusatzfeldDefinitionenView"));
const TeilnahmeZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/TeilnahmeZusatzfeldDefinitionenBreadcrumb"));
const AdresseZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/AdresseZusatzfeldDefinitionenBreadcrumb"));
const RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb"));
const RessourcenkategorieZusatzfeldDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/RessourcenkategorieZusatzfeldDefinitionBreadcrumb"));
const RessourcenkategorieZusatzfeldDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/RessourcenkategorieZusatzfeldDefinitionenBreadcrumb"));
const RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenView"));
const RessourcenkategorieZusatzfeldDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/RessourcenkategorieZusatzfeldDefinitionDetailsView"));
const RessourcenkategorieZusatzfeldDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/RessourcenkategorieZusatzfeldDefinitionenNavigationView"));
const RessourcenkategorieZusatzfeldDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/RessourcenkategorieZusatzfeldDefinitionenView"));
const RessourcenkategorieZusatzfeldDefinitionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/RessourcenkategorieZusatzfeldDefinitionView"));
const BrandingBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Teilnahmen/Components/BrandingBreadcrumb"));
const KonfigurierbareAnzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/KonfigurierbareAnzeigenBreadcrumb"));
const KonfigurierbareAnzeigeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/KonfigurierbareAnzeigeBreadcrumb"));
const KonfigurierbareAnzeigenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigenView"));
const KonfigurierbareAnzeigeView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeView"));
const KonfigurierbareAnzeigeDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeDetailsView"));
const KonfigurierbareAnzeigenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigenNavigationView"));
const KonfigurierbareAnzeigeBloeckeView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeBloeckeView"));
const KonfigurierbareAnzeigeBloeckeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/KonfigurierbareAnzeigeBloeckeBreadcrumb"));
const KonfigurierbareAnzeigeBlockBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/KonfigurierbareAnzeigeBlockBreadcrumb"));
const KonfigurierbareAnzeigeBlockView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeBlockView"));
const KonfigurierbareAnzeigeBlockDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeBlockDetailsView"));
const KonfigurierbareAnzeigeBloeckeNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/KonfigurierbareAnzeigeBloeckeNavigationView"));
const SeminaranzeigenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminaranzeigenView"));
const SeminaranzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminaranzeigenBreadcrumb"));
const SeminareBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/SeminareBreadcrumb"));
const SeminarBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/SeminarBreadcrumb"));
const SeminarreiheanzeigenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/SeminarreiheanzeigenView"));
const SeminarreiheanzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/SeminarreiheanzeigenBreadcrumb"));
const SeminarreihenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/SeminarreihenBreadcrumb"));
const SeminarreiheBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/SeminarreiheBreadcrumb"));
const DozierendanzeigenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/DozierendanzeigenView"));
const DozierendanzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/DozierendanzeigenBreadcrumb"));
const DozierendeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/DozierendeBreadcrumb"));
const DozierendBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen" */"../../Seminare/Components/DozierendBreadcrumb"));
const ArtikelanzeigenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Views/ArtikelanzeigenView"));
const ArtikelanzeigenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */ "../Components/ArtikelanzeigenBreadcrumb"));
const PreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/PreisBreadcrumb"));
const PreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreisDetailsView"));
const PreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../../Seminare/Components/PreiseBreadcrumb"));
const PreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreiseNavigationView"));
const PreiseView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreiseView"));
const PreispositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/PreispositionBreadcrumb"));
const PreispositionDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreispositionDetailsView"))
const PreispositionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../../Seminare/Components/PreispositionenBreadcrumb"));
const PreispositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreispositionenNavigationView"))
const PreispositionenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreispositionenView"));
const PreispositionView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreispositionView"));
const PreisView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/PreisView"));
const KonfigurierbareListenansichtenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtenView"));
const KonfigurierbareListenansichtView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtView"));
const KonfigurierbareListenansichtenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtenNavigationView"));
const KonfigurierbareListenansichtDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtDetailsView"));
const KonfigurierbareListenansichtenBreadcrumb = React.lazy(() => import(/* webpackchunkName: "Einstellungen" */"../Components/KonfigurierbareListenansichtenBreadcrumb"));
const KonfigurierbareListenansichtBreadcrumb = React.lazy(() => import(/* webpackchunkName: "Einstellungen" */"../Components/KonfigurierbareListenansichtBreadcrumb"));
const KonfigurierbareListenansichtSortierungView = React.lazy(() => import(/* webpackchunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtSortierungView"));
const KonfigurierbareListenansichtFilterView = React.lazy(() => import(/* webpackchunkName: "Einstellungen" */"../Views/KonfigurierbareListenansichtFilterView"));
const AnredenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/AnredenView"));
const AnredenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/AnredenBreadcrumb"))
const AnredeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/AnredeBreadcrumb"))
const AnredenNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/AnredenNavigationView"))
const AnredeView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/AnredeView"));
const EMailTexteView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/EMailTexteView"));
const EMailTextView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/EMailTextView"));
const EMailTextNavigationView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/EMailTextNavigationView"));
const EMailTexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/EMailTexteBreadcrumb"));
const EMailTextBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/EMailTextBreadcrumb"));
const EMailEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/EMailEinstellungenView"));
const EMailEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/EMailEinstellungenDetailsView"));
const EMailEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/EMailEinstellungenBreadcrumb"));
const GruppenveranstaltungEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/GruppenveranstaltungEinstellungenView"));
const GruppenveranstaltungEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Views/GruppenveranstaltungEinstellungenDetailsView"));
const GruppenveranstaltungEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Einstellungen" */"../Components/GruppenveranstaltungEinstellungenBreadcrumb"));


const PREISPATH = "/preis/:preisId";
const PREISPOSITIONPATH = `${PREISPATH}/position/:preispositionId`;
const ZAHLUNGSDIENSTLEISTERPATH = "/zahlungsdienstleister";
const ZUSATZFELDERPATH = "/zusatzfelder";
export const TEILNAHMEZUSATZFELDDEFINITIONPATH = "/zusatzfelder/teilnahme/:zusatzfeldDefinitionId";
export const ADRESSEZUSATZFELDDEFINITIONPATH = "/zusatzfelder/adresse/:zusatzfeldDefinitionId";
export const SEMINARZUSATZFELDDEFINITIONPATH = "/zusatzfelder/seminar/:zusatzfeldDefinitionId";
export const DOZIERENDZUSATZFELDDEFINITIONPATH = "/zusatzfelder/dozierend/:zusatzfeldDefinitionId";
export const RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH = "/zusatzfelder/ressourcenkategorie/:zusatzfeldDefinitionId";

export function createArtikelanzeigenRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => JSX.Element[]
): AppRouterDefinition[] {
    pathPrefix ??= "";
    return [
        {
            exact: true,
            parentPath: `${pathPrefix}/artikel/:artikelId`,
            path: `${pathPrefix}/artikel/:artikelId/portalansichten`,
            render: props => <ArtikelanzeigenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelanzeigenBreadcrumb {...props} />,
            ],
        },
    ];
}

export const einstellungenRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: ZAHLUNGSDIENSTLEISTERPATH,
        render: (renderProps: any) => <ZahlungsdienstleisterView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: `${ZAHLUNGSDIENSTLEISTERPATH}/paypal`,
        parentPath: ZAHLUNGSDIENSTLEISTERPATH,
        render: (renderProps: any) => <PayPalKontoView {...renderProps} />,
        createBreadcrumbs: () => [<PayPalKontoBreadcrumb />]
    },
    {
        exact: true,
        path: `${ZAHLUNGSDIENSTLEISTERPATH}/stripe`,
        parentPath: ZAHLUNGSDIENSTLEISTERPATH,
        render: (renderProps: any) => <StripeKontoView {...renderProps} />,
        createBreadcrumbs: () => [<StripeKontoBreadcrumb />]
    },
    {
        exact: true,
        path: `${ZAHLUNGSDIENSTLEISTERPATH}/zahlungsmethoden`,
        parentPath: ZAHLUNGSDIENSTLEISTERPATH,
        render: (renderProps: any) => <ZahlungsmethodenView {...renderProps} />,
        createBreadcrumbs: () => []
    },
    {
        path: ZUSATZFELDERPATH,
        render: (renderProps: any) => <ZusatzfeldDefinitionenTabsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/seminar`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <SeminarZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminarEinstellungenZusatzfelderBreadcrumb />,
            <SeminarZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/seminarreihe`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <SeminarreiheZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        path: `${ZUSATZFELDERPATH}/seminarreihe/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarreiheZusatzfeldDefinitionView {...renderProps} />}
                left={() => <SeminarreiheZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionenBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/seminarreihe/:zusatzfeldDefinitionId`,
        parentPath: `${ZUSATZFELDERPATH}/seminarreihe/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => <SeminarreiheZusatzfeldDefinitionDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionenBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/seminarreihe/:zusatzfeldDefinitionId/auswahlmoeglichkeiten`,
        parentPath: `${ZUSATZFELDERPATH}/seminarreihe/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => <SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionenBreadcrumb />,
            <SeminarreiheZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <SeminarreiheZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/dozierend`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <DozierendZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <DozierendZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        path: `${ZUSATZFELDERPATH}/dozierend/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <DozierendZusatzfeldDefinitionView {...renderProps} />}
                left={() => <DozierendZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <DozierendZusatzfeldDefinitionenBreadcrumb />,
            <DozierendZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/dozierend/:zusatzfeldDefinitionId`,
        parentPath: `${ZUSATZFELDERPATH}/dozierend/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => <DozierendZusatzfeldDefinitionDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <DozierendZusatzfeldDefinitionenBreadcrumb />,
            <DozierendZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/dozierend/:zusatzfeldDefinitionId/auswahlmoeglichkeiten`,
        parentPath: `${ZUSATZFELDERPATH}/dozierend/:zusatzfeldDefinitionId`,
        render: (renderProps: any) => <DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <DozierendZusatzfeldDefinitionenBreadcrumb />,
            <DozierendZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <DozierendZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/adresse`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <AdresseZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <AdresseZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/teilnahme`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <TeilnahmeZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <TeilnahmeZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: `${ZUSATZFELDERPATH}/ressourcenkategorie`,
        parentPath: ZUSATZFELDERPATH,
        render: (renderProps: any) => <RessourcenkategorieZusatzfeldDefinitionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionenBreadcrumb />,
        ],
    },
    {
        path: TEILNAHMEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <TeilnahmeZusatzfeldDefinitionView {...renderProps} />}
                left={() => <TeilnahmeZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <TeilnahmeZusatzfeldDefinitionenBreadcrumb />,
            <TeilnahmeZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: TEILNAHMEZUSATZFELDDEFINITIONPATH,
        parentPath: TEILNAHMEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <TeilnahmeZusatzfeldDefinitionDetailsView
            {...renderProps}/>,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: `${TEILNAHMEZUSATZFELDDEFINITIONPATH}/auswahlmoeglichkeiten`,
        parentPath: TEILNAHMEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenView
            {...renderProps}/>,

        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <TeilnahmeZusatzfeldDefinitionenBreadcrumb />,
            <TeilnahmeZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <TeilnahmeZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        path: ADRESSEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <AdresseZusatzfeldDefinitionView {...renderProps} />}
                left={() => <AdresseZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <AdresseZusatzfeldDefinitionenBreadcrumb />,
            <AdresseZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: ADRESSEZUSATZFELDDEFINITIONPATH,
        parentPath: ADRESSEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <AdresseZusatzfeldDefinitionDetailsView
            {...renderProps}/>,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: `${ADRESSEZUSATZFELDDEFINITIONPATH}/auswahlmoeglichkeiten`,
        parentPath: ADRESSEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenView
            {...renderProps}/>,

        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <AdresseZusatzfeldDefinitionenBreadcrumb />,
            <AdresseZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <AdresseZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        path: SEMINARZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarZusatzfeldDefinitionView {...renderProps} />}
                left={() => <SeminarZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarZusatzfeldDefinitionenBreadcrumb />,
            <SeminarZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: SEMINARZUSATZFELDDEFINITIONPATH,
        parentPath: SEMINARZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <SeminarZusatzfeldDefinitionDetailsView
            {...renderProps}/>,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: `${SEMINARZUSATZFELDDEFINITIONPATH}/auswahlmoeglichkeiten`,
        parentPath: SEMINARZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenView
            {...renderProps}/>,

        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <SeminarZusatzfeldDefinitionenBreadcrumb />,
            <SeminarZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <SeminarZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        path: RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <RessourcenkategorieZusatzfeldDefinitionView {...renderProps} />}
                left={() => <RessourcenkategorieZusatzfeldDefinitionenNavigationView {...renderProps} />}
            />),
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionenBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH,
        parentPath: RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <RessourcenkategorieZusatzfeldDefinitionDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionenBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        path: `${RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH}/auswahlmoeglichkeiten`,
        parentPath: RESSOURCENKATEGORIEZUSATZFELDDEFINITIONPATH,
        render: (renderProps: any) => <RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <TeilnahmeEinstellungenZusatzfelderBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionenBreadcrumb />,
            <RessourcenkategorieZusatzfeldDefinitionBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />,
            <RessourcenkategorieZusatzfeldDefinitionAuswahlmoeglichkeitenBreadcrumb zusatzfeldDefinitionId={createProps.zusatzfeldDefinitionId} />
        ],
    },
    {
        exact: true,
        parentPath: "/branding",
        path: "/branding/:konfigurierbareAnzeigeTyp/ansichten",
        render: props => <KonfigurierbareAnzeigenView {...props} />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
        ]
    },
    {
        path: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId",
        render: props => <VerticalSplit
            right={() => <KonfigurierbareAnzeigeView {...props} />}
            left={() => <KonfigurierbareAnzeigenNavigationView {...props} />}
        />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId",
        path: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId",
        render: props => <KonfigurierbareAnzeigeDetailsView {...props} />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId",
        path: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId/bloecke",
        render: props => <KonfigurierbareAnzeigeBloeckeView {...props} />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBloeckeBreadcrumb {...props} />,
        ],
    },
    {
        path: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId/block/:konfigurierbareAnzeigeBlockId",
        render: props => <VerticalSplit
            right={() => <KonfigurierbareAnzeigeBlockView {...props} />}
            left={() => <KonfigurierbareAnzeigeBloeckeNavigationView {...props} />}
        />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBloeckeBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBlockBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId/block/:konfigurierbareAnzeigeBlockId",
        path: "/branding/:konfigurierbareAnzeigeTyp/ansicht/:konfigurierbareAnzeigeId/block/:konfigurierbareAnzeigeBlockId",
        render: props => <KonfigurierbareAnzeigeBlockDetailsView {...props} />,
        createBreadcrumbs: props => [
            <BrandingBreadcrumb />,
            <KonfigurierbareAnzeigenBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBloeckeBreadcrumb {...props} />,
            <KonfigurierbareAnzeigeBlockBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/seminar/:seminarId",
        path: "/seminar/:seminarId/portalansichten",
        render: props => <SeminaranzeigenView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb {...props} />,
            <SeminarBreadcrumb {...props} />,
            <SeminaranzeigenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/seminarreihe/:seminarreiheId",
        path: "/seminarreihe/:seminarreiheId/portalansichten",
        render: props => <SeminarreiheanzeigenView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreiheanzeigenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: "/dozierend/:dozierendId",
        path: "/dozierend/:dozierendId/portalansichten",
        render: props => <DozierendanzeigenView {...props} />,
        createBreadcrumbs: props => [
            <DozierendeBreadcrumb {...props} />,
            <DozierendBreadcrumb {...props} />,
            <DozierendanzeigenBreadcrumb {...props} />,
        ],
    },
    {
        path: PREISPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <PreisView {...renderProps} />}
                left={() => <PreiseNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
            <PreisBreadcrumb
                preisId={createProps.preisId}
            />,
        ],
    },
    {
        exact: true,
        path: PREISPATH,
        parentPath: PREISPATH,
        render: (renderProps: any) => <PreisDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
            <PreisBreadcrumb
                preisId={createProps.preisId}
            />,
        ],
    },
    {
        exact: true,
        path: `${PREISPATH}/positionen`,
        parentPath: PREISPATH,
        render: (renderProps: any) => <PreispositionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
            <PreisBreadcrumb
                preisId={createProps.preisId}
            />,
            <PreispositionenBreadcrumb
                preisId={createProps.preisId}
            />
        ],
    },
    {
        path: PREISPOSITIONPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <PreispositionView {...renderProps} />}
                left={() => <PreispositionenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
            <PreisBreadcrumb
                preisId={createProps.preisId}
            />,
            <PreispositionenBreadcrumb
                preisId={createProps.preisId}
            />,
            <PreispositionBreadcrumb
                preisId={createProps.preisId}
                preispositionId={createProps.preispositionId}
            />
        ],
    },
    {
        exact: true,
        path: PREISPOSITIONPATH,
        parentPath: PREISPOSITIONPATH,
        render: (renderProps: any) => <PreispositionDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
            <PreisBreadcrumb
                preisId={createProps.preisId}
            />,
            <PreispositionBreadcrumb
                preisId={createProps.preisId}
                preispositionId={createProps.preispositionId}
            />
        ],
    },
    {
        exact: true,
        path: "/preise",
        render: (renderProps: any) => <PreiseView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <PreiseBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: "/konfigurierbareListenansichten",
        render: (renderProps: any) => <KonfigurierbareListenansichtenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <KonfigurierbareListenansichtenBreadcrumb />
        ],
    },
    {
        path: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp",
        render: (renderProps: any) => <VerticalSplit
            right={() => <KonfigurierbareListenansichtView {...renderProps} />}
            left={() => <KonfigurierbareListenansichtenNavigationView {...renderProps}/>}
        />,
        createBreadcrumbs: (createProps: any) => [
            <KonfigurierbareListenansichtenBreadcrumb />,
            <KonfigurierbareListenansichtBreadcrumb
                konfigurierbareListenansichtTyp={createProps.konfigurierbareListenansichtTyp}
            />

        ],
    },
    {
        exact: true,
        path: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp",
        parentPath: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp",
        render: (renderProps: any) => <KonfigurierbareListenansichtDetailsView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp/sortierung",
        parentPath: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp",
        render: (renderProps: any) => <KonfigurierbareListenansichtSortierungView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp/filter",
        parentPath: "/konfigurierbareListenansicht/:konfigurierbareListenansichtTyp",
        render: (renderProps: any) => <KonfigurierbareListenansichtFilterView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: "/branding/anreden",
        parentPath: "/branding",
        render: (renderProps) => <AnredenView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <AnredenBreadcrumb />
        ],
    },
    {
        path: "/branding/anreden/:anredeId",
        render: (renderProps) => <VerticalSplit
            left={() => <AnredenNavigationView {...renderProps} />}
            right={() => <AnredeView {...renderProps} />}
        />,
        createBreadcrumbs: (createProps) => [
            <BrandingBreadcrumb />,
            <AnredenBreadcrumb />,
            <AnredeBreadcrumb anredeId={createProps.anredeId} />
        ],
    },
    {
        path: "/eMailTexte",
        render: () => <EMailTexteView />,
        createBreadcrumbs: () => [
            <EMailTexteBreadcrumb />,
        ],
    },
    {
        path: "/eMailTexte/:eMailTextId",
        render: (renderProps) => <VerticalSplit
            left={() => <EMailTextNavigationView {...renderProps} />}
            right={() => <EMailTextView {...renderProps} />}
        />,
        createBreadcrumbs: (createProps) => [
            <EMailTexteBreadcrumb />,
            <EMailTextBreadcrumb eMailTextId={createProps.eMailTextId} />,
        ],
    },
    {
        path: "/eMailEinstellungen",
        render: props => <EMailEinstellungenView {...props} />,
        createBreadcrumbs: props => [
            <EMailEinstellungenBreadcrumb />,
        ],
    },
    {
        path: "/eMailEinstellungen",
        parentPath: "/eMailEinstellungen",
        render: props => <EMailEinstellungenDetailsView {...props} />,
        createBreadcrumbs: props => [
            <EMailEinstellungenBreadcrumb />,
        ],
    },
    {
        path: "/gruppenveranstaltungEinstellungen",
        render: props => <GruppenveranstaltungEinstellungenView {...props} />,
        createBreadcrumbs: props => [
            <GruppenveranstaltungEinstellungenBreadcrumb />,
        ],
    },
    {
        path: "/gruppenveranstaltungEinstellungen",
        parentPath: "/gruppenveranstaltungEinstellungen",
        render: props => <GruppenveranstaltungEinstellungenDetailsView {...props} />,
        createBreadcrumbs: props => [
            <GruppenveranstaltungEinstellungenBreadcrumb />,
        ],
    },
];